export default __webpack_public_path__ + "1ccdb18218ef9b3c5d36b81c5855dcc7.gif";